import React from 'react'
import { ModalBackdrop, ModalContainer, ModalContent } from 'is24-corecss'
import styles from './VideoPreviewModal.module.css'
import { StreamingVideoUrl } from '../../../../../../../../../@types/types'

type VideoPreviewModalProps = {
  visible: boolean
  onClick: () => void
  videoInfoSourceUrls: StreamingVideoUrl[]
}

const VideoPreviewModal: React.FC<VideoPreviewModalProps> = ({ visible, onClick, videoInfoSourceUrls }) => {
  return (
    <ModalBackdrop visible={visible} className='absolute-reference' onClose={onClick}>
      <ModalContainer onClose={onClick}>
        <ModalContent>
          <video className={`${styles.videoPreview} border-radius-rounded`} controls data-testid='video-preview'>
            {videoInfoSourceUrls.map((src) => (
              <source key={src.url} src={src.url} />
            ))}
          </video>
        </ModalContent>
      </ModalContainer>
    </ModalBackdrop>
  )
}
export default VideoPreviewModal
